var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    !(_vm.mode == "region") &&
    _vm.mode == "time" &&
    !_vm.reset &&
    _vm.params.month
      ? _vm.__map(_vm.months, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = _vm.formatNumber(item)
          return {
            $orig: $orig,
            m0: m0,
          }
        })
      : null
  var l1 =
    !(_vm.mode == "region") &&
    _vm.mode == "time" &&
    !_vm.reset &&
    _vm.params.day
      ? _vm.__map(_vm.days, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m1 = _vm.formatNumber(item)
          return {
            $orig: $orig,
            m1: m1,
          }
        })
      : null
  var l2 =
    !(_vm.mode == "region") &&
    _vm.mode == "time" &&
    !_vm.reset &&
    _vm.params.hour
      ? _vm.__map(_vm.hours, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m2 = _vm.formatNumber(item)
          return {
            $orig: $orig,
            m2: m2,
          }
        })
      : null
  var l3 =
    !(_vm.mode == "region") &&
    _vm.mode == "time" &&
    !_vm.reset &&
    _vm.params.minute
      ? _vm.__map(_vm.minutes, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m3 = _vm.formatNumber(item)
          return {
            $orig: $orig,
            m3: m3,
          }
        })
      : null
  var l4 =
    !(_vm.mode == "region") &&
    _vm.mode == "time" &&
    !_vm.reset &&
    _vm.params.second
      ? _vm.__map(_vm.seconds, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m4 = _vm.formatNumber(item)
          return {
            $orig: $orig,
            m4: m4,
          }
        })
      : null
  var l5 =
    !(_vm.mode == "region") &&
    !(_vm.mode == "time") &&
    _vm.mode == "selector" &&
    !_vm.reset
      ? _vm.__map(_vm.range, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m5 = _vm.getItemValue(item, "selector")
          return {
            $orig: $orig,
            m5: m5,
          }
        })
      : null
  var l7 =
    !(_vm.mode == "region") &&
    !(_vm.mode == "time") &&
    !(_vm.mode == "selector") &&
    _vm.mode == "multiSelector"
      ? _vm.__map(_vm.range, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var l6 = !_vm.reset
            ? _vm.__map(item, function (item1, index1) {
                var $orig = _vm.__get_orig(item1)
                var m6 = _vm.getItemValue(item1, "multiSelector")
                return {
                  $orig: $orig,
                  m6: m6,
                }
              })
            : null
          return {
            $orig: $orig,
            l6: l6,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
        l2: l2,
        l3: l3,
        l4: l4,
        l5: l5,
        l7: l7,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }